import axios from "axios";

const BACKEND_URL = 'https://ciarakidz.com';
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ck_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatRand = (n) =>
  "R " + Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const mediaUrl = (p) => {
  if (!p) return "";
  return p.startsWith("/api") ? `${BACKEND_URL}${p}` : p;
};

export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_ciaras-kidz-shop/artifacts/7akla845_ess%20slogo%20%281%29.png";

export const HERO_VIDEO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_ciaras-kidz-shop/artifacts/ot48pkdd_Ciara%27s%20Promo%20Video.mp4";

export const STOCK_NOTICE = "Stock available 1st October 2026";

export const CATEGORIES = [
  { key: "babies", label: "Babies", sub: "0-24 Months" },
  { key: "toddlers", label: "Toddlers", sub: "1-6 Years" },
  { key: "kids", label: "Kids", sub: "3-8 Years" },
  { key: "tweens", label: "Tweens", sub: "4-11 Years" },
];

export default api;
